import { MentionMetadataTypesEnum } from '../enums/mention-metadata-types.enum';

export const defaultSelectedMentionMetadataTypes = [
    MentionMetadataTypesEnum.outlet,
    MentionMetadataTypesEnum.author,
    MentionMetadataTypesEnum.publishedDate
];
